import React from "react";
import { Navbar } from "react-bootstrap";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import LogButton from "../../atoms/LogButton";

import {
  COLOR_TEXT_WHITE,
  COLOR_PRIMARY,
  PRIMARY_KUBBE,
  DARK_KUBBE,
  SECONDARY_KUBE,
} from "../../../constants/Colors";
import LogLogo from "../../atoms/LogLogo";

const NavbarStyled = styled(Navbar)`
  background: none !important;
  border-bottom: none !important;
  padding-right: 0px;
  padding-left: 0px;
`;

const DivButtonNav = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    gap: 10px;
  }
`;

const DivAuthButtonNav = styled.div`
  flex-shrink: 0;

  display: flex;
  justify-content: space-evenly;

  @media (max-width: 1160px) {
    flex-grow: 1;
    flex-wrap: wrap;
  }
`;

const NavButtonStyled = styled(LogButton)`
  color: ${DARK_KUBBE};
  padding: 8px 15px;
  background: none;
  border: none;
  white-space: nowrap;
  &:hover {
    color: #ffffff;
    background: none;
    border: none;
  }
`;

const NavButtonSignInStyled = styled(LogButton)`
  color: ${SECONDARY_KUBE};
  padding: 8px 15px;
  background: "none";
  border: none;
  white-space: nowrap;
  &:hover {
    color: #ffffff;
    background: none;
    border: none;
  }
`;

const NavBarRoot = () => {
  const history = useHistory();
  return (
    <NavbarStyled expand="lg">
      <Navbar.Brand to="#" onClick={(e) => e.preventDefault()}>
        <LogLogo className="mt-0" />
      </Navbar.Brand>
      <Navbar.Toggle
        aria-controls="navbarScroll"
        className="navbar-dark"
        color="dark"
      />
      <Navbar.Collapse id="navbarScroll" className="navbar-dark" color="light">
        <DivButtonNav className="p-2" navbarScroll>
          <NavButtonStyled
            title="Inicio"
            border="curve"
            onClick={() => history.push("/")}
          />
          <NavButtonStyled
            title="Transportistas"
            border="curve"
            onClick={() => history.push("/register?type=carriers")}
          />
          <NavButtonStyled
            title="Dadores de carga"
            border="curve"
            onClick={() => history.push("/register?type=Loadgiver")}
          />
          <NavButtonStyled
            title="Contacto"
            color="light"
            border="curve"
            onClick={() => {
              history.push("/?scroll=contact");
            }}
          />
        </DivButtonNav>
        <DivAuthButtonNav navbarScroll>
          <NavButtonSignInStyled
            title="Ya tengo cuenta, quiero ingresar"
            color="light"
            border="curve"
            onClick={() => history.push("/sign-in")}
          />
          <LogButton
            title="Soy nuevo, quiero registrarme"
            color="primaryDark"
            className={"ml-2"}
            border="curve"
            onClick={() => history.push("/which-user")}
          />
        </DivAuthButtonNav>
      </Navbar.Collapse>
    </NavbarStyled>
  );
};

export default NavBarRoot;
